import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    standalone: false
})
export class TitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
